import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { NavLink } from "react-router-dom";
import Switch from "react-switch";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import AddReferreePopup from "../../superAdminAllComponent/superAdminRefferalsCode/referralsPopup/AddReferreePopup";

function DunzoDeliverySettings(props) {
  const RenderTableBody = () => {
    return (
      <React.Fragment>
        <TableBody />
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Delivery Settings
                  <br />
                </div>
                <div className="col-6 text-right">
                  <NavLink
                    to="/addDunzoPartners"
                    className="mr-4 px-5 py-2 btn addBtnRed f12-700"
                    style={{ color: "#f26856" }}
                  >
                    + Add new
                  </NavLink>
                </div>
              </div>
              <div className="row">
                <div className="col-4 d-flex">
                  <Image
                    //   onClick={() =>
                    //     setState({
                    //       ...state,
                    //       showSearch: !state.showSearch,
                    //     })
                    //   }
                    alt="filter"
                    title="filter"
                    width="80px"
                    src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                  />
                  <div
                    className="f10-400"
                    align="center"
                    // onClick={() => showFilter(!filter)}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    // onClick={props.handleClick}
                  >
                    <img
                      src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>
                  <div className="f10-400" align="center">
                    <img
                      src={require("../../../../assets/images/iconButton/downloadbtn.svg")}
                      width="80px"
                      alt="icon"
                    />
                    <br />
                  </div>
                </div>
                <div className="col-5"></div>
                <div className="col-3 justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={() => {}} />
                  </div>
                </div>
              </div>
              <hr />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "15%" }} className="f12-400">
                        S.No.
                      </td>
                      <td style={{ width: "15%" }} className="f12-400">
                        Delivery <br />
                        Partner Name
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Added Cities
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Payment terms
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        status
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Action
                      </td>
                    </tr>
                  </thead>
                  {RenderTableBody()}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row" onClick={showTr}>
                <td style={{ width: "15%" }}>
                  <div>
                    <h5 className="font_16_m ">1</h5>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <h3 className="font_20_m">Dunzo</h3>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500">Pune, Hyderabad, Mumbai</div>
                </td>
                <td style={{ width: "20%" }}>
                  <div
                    style={{
                      fontSize: "12px",
                      fontFamily: "Roboto-Regular",
                      color: "#212121",
                      lineHeight: "16px",
                    }}
                  >
                    View Payment terms
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="">
                    <Switch
                      onClick={(e) => {}}
                      onChange={() => {}}
                      checked={true}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={15}
                      width={41}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                    />
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500">
                    <div className="f12-400 d-flex">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        // onClick={() => seShowDeletevideo(true)}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/Delete.svg")}
                          alt="Delete"
                          title="Delete"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        // onClick={
                        //   props?.event?.isOnline
                        //     ? () => props.handleShowView(props.event)
                        //     : () => props.handleShowView2(props.event)
                        // }
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/eye.svg")}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </Button>
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        // onClick={props.editDataAction}
                      >
                        <Image
                          src={require("../../../../assets/images/UserManagement/pencil.svg")}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </Button>
                    </div>
                  </div>
                </td>
              </tr>
              {/* {TrDetail && (
                <>
                  <tr className="sd_accordion_body">
                    <td style={{ width: "18%" }}>
                      <div className="f12-400">Email ID</div>
                      <div className="f12-400">mail@gmail.com</div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">Grade / Band</div>
                      <div className="f12-400 mt-2">-</div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-400">City/Location</div>
                      <div className="f12-400 mt-2">pune</div>
                    </td>
                  </tr>
                </>
              )} */}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default DunzoDeliverySettings;
